/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log('Contive PWA: service worker ready.')
    },
    registered () {
      console.log('Contive PWA: service worker registered.')
    },
    cached () {
      console.log('Contive PWA: content cached for offline use.')
    },
    updatefound () {
      console.log('Contive PWA: new content is downloading.')
    },
    updated () {
      console.log('Contive PWA: new content is available; refresh to update.')
    },
    offline () {
      console.log('Contive PWA: offline mode active.')
    },
    error (error) {
      console.error('Contive PWA: service worker registration error:', error)
    }
  })
}
